import { CommonModule } from '@angular/common';
import { Component, computed, inject, OnDestroy, OnInit, signal } from '@angular/core';
import { NavigationEnd, Router, RouterModule } from '@angular/router';
import { LogoComponent } from '@circlek-global/lds-components';
import { LangChangeEvent, TranslateModule, TranslateService } from '@ngx-translate/core';
import { filter, Subscription } from 'rxjs';

import { UserService } from 'src/app/services/user.service';
import { ApiService } from '../../api/api.service';
import { AuthService } from '../../auth/auth.service';
import { LanguageSelectorComponent } from '../language-selector/language-selector.component';

@Component({
    selector: 'app-header',
    imports: [CommonModule, LanguageSelectorComponent, LogoComponent, TranslateModule, RouterModule],
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit, OnDestroy {
  currentRoute: string = '';
  private readonly router = inject(Router);
  private readonly authService = inject(AuthService);
  private readonly apiService = inject(ApiService);
  private readonly translate = inject(TranslateService);
  private readonly userService = inject(UserService);
  region = this.apiService.region();
  userName = computed(() => this.userService.userData()?.firstName ?? '');
  currentLang = signal('en');
  langChangeSub!: Subscription;

  constructor() {
    this.langChangeSub = this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
      this.currentLang.set(event.lang);
    });
  }

  ngOnInit() {
    this.router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe(() => {
      this.currentRoute = this.router.url;
    });
  }

  logout() {
    return this.authService.logout();
  }

  isActive(route: string): boolean {
    const normalizedCurrentRoute = this.normalizeRoute(this.currentRoute);
    const normalizedRoute = this.normalizeRoute(route);

    return normalizedCurrentRoute === normalizedRoute;
  }

  private normalizeRoute(route: string): string {
    return route.replace(/^\/[a-z]{2}\//, '/');
  }

  ngOnDestroy() {
    if (this.langChangeSub) {
      this.langChangeSub.unsubscribe();
    }
  }
}
